module.exports = __webpack_public_path__ + "static/media/collect.b2e2ac5c.svg";